import { forwardRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Slide,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// hooks
import useAuth from '../../hooks/useAuth';
import useResponsive from '../../hooks/useResponsive';
// components
import DIOText from '../../components/DIOText';
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function EmbedOnboardingDialog({ isOpen, closeDialog }) {
  const { user } = useAuth();
  const smUp = useResponsive('up', 'sm');

  const goDocSite = () => {
    window.open('https://docs.dio.so/dio', '_blank', 'noopener, noreferrer');
  }

  return (
    <Dialog maxWidth="md" fullWidth open={isOpen} TransitionComponent={Transition}>
      <DialogTitle paragraph>
      {user?.employee?.company?.[0]?.name} 담당자님,<br /><DIOText /> 서비스 이용 방법을 확인해보세요!
      </DialogTitle>
      <DialogContent sx={{ pb: 0 }}>
        {!smUp && (
        <Typography variant="body2" sx={{ mb: 2 }}>
          이용방법은 PC 화면에 최적화되어 있습니다. <br />
          <b>자세히 보기</b>를 선택하면, 이용 방법을 문서로 확인할 수 있습니다.
        </Typography>
        )}
        {/* embed */}
        <Stack
          direction="row"
          sx={{
            width: 1,
            display: 'flex',
            height: smUp ? '560px' : '280px',
          }}
        >
          <iframe
            src="https://app.supademo.com/embed/m69E6hD6brtVSLKaSG-Jc"
            frameBorder={0}
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        </Stack>
        {/* embed */}
      </DialogContent>
      <DialogActions>
        <Stack direction={{ xs: "column-reverse", sm: "row" }} spacing={1} sx={{ width: 1, justifyContent: "flex-end" }}>
          <LoadingButton
            size="large"
            onClick={closeDialog}
            sx={{ px: 4 }}
          >
            닫기
          </LoadingButton>
          <LoadingButton
            size="large"
            variant="contained"
            onClick={goDocSite}
            startIcon={<Iconify icon="eva:external-link-outline" />}
            sx={{ px: 4 }}
          >
            자세히 보기
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}
